import React, { ReactElement, useEffect, useState } from 'react';
import { UpOutlined } from '@ant-design/icons';
import { Col, Collapse, Popconfirm, Row, Switch, Tooltip } from 'antd';
import SmallCalendar from './SmallCalendar';
import { GUTTOR_SPACE_SMALL, INVENTROY_CONSTANTS, TOOLTIP_TEXT } from '../../../shared/constants/commonConstants';
import SlotsCalendar from './SlotsCalendar';
import { ReactComponent as CalendarIcon } from '../../../assets/images/svg/i_calendar.svg';

const CardActions = ({ onProfileSwitchToggle, data, onCollapse, onRefresh, isDisabled }: any): ReactElement => {
  const { isActive, workingSlots: slots } = data ? data : {} as any;
  const { Panel: CardPanel } = Collapse;
  const [activeKey, setActiveKey] = useState(0);
  useEffect((): void => {
    setActiveKey(data.isExpanded ? 1 : 0);
  }, [data.isExpanded]);

  const onToggleSwitch = (): void => {
    onProfileSwitchToggle(!isActive);
  };

  const setCollapsible = (): void => {
    if (!isDisabled) {
      onCollapse(data, !data.isExpanded);
      setActiveKey(activeKey ? 0 : 1);
    }
  };

  return (
    <Collapse bordered={false} key="i" activeKey={activeKey} accordion={false} className={`${!isActive ? 'doc-card-cal doc-card-disabled' : 'doc-card-cal'}`}>
      <CardPanel disabled={isDisabled} showArrow={false} header={
        <div onClick={setCollapsible}>
          {!activeKey ? (
            <Row gutter={GUTTOR_SPACE_SMALL}>
              <Col md={16} style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title={TOOLTIP_TEXT.addWeeklyShcedule}>
                  <CalendarIcon className="fill-primary mr-10" /></Tooltip>
                <SmallCalendar slots={slots} />
              </Col>
              <Col md={8} className="text-right" onClick={(e: any): void => e.stopPropagation()}>
                <span className="fsize_sm">{isActive ? 'Active ' : 'Inactive '}</span>
                <Popconfirm
                  disabled={isDisabled}
                  title={isActive ? INVENTROY_CONSTANTS.disableConfirmMessage : INVENTROY_CONSTANTS.enableConfirmMessage}
                  onConfirm={onToggleSwitch}
                  okText="Yes"
                  cancelText="No"
                >
                  <Switch disabled={isDisabled} style={{ backgroundColor: isActive ? 'var(--cr_success)' : '', pointerEvents: 'all' }}
                    checked={isActive} size="small" />
                </Popconfirm>
              </Col>
            </Row>
          ) : <UpOutlined />}
        </div>} key="1">
        <SlotsCalendar action={'Update'} data={data} isInline={true} onRefresh={onRefresh} />
      </CardPanel>
    </Collapse>
  );
};

export default CardActions;
